import { RouteType } from "../types/route.type";
import LoginPage from "../pages/login/LoginPage";
import HomePage from "../pages/home/HomePage";
import NotFoundPage from "../pages/notfound/NotFoundPage";
import TestPage from "../pages/test/TestPage";
import GroupPage from "../pages/group";
import CategoryPage from "../pages/category";
import TrashPage from "../pages/trash";
import BiddingStatisticsPage from "../pages/bidding-statistics/BiddingStatisticsPage";

const publicRoutes: RouteType[] = [
  {
    id: "notfound",
    path: "*",
    component: NotFoundPage,
  },
  {
    id: "test",
    path: "/test",
    component: TestPage,
  },
];

const restrictedRoutes: RouteType[] = [
  {
    id: "login",
    path: "/login",
    component: LoginPage,
  },
];
const privateRoutes: RouteType[] = [
  {
    id: "/report/kqtt",
    path: "/report/kqtt",
    component: HomePage,
  },
  {
    id: "list",
    path: "/list/:code",
    component: CategoryPage,
  },
  {
    id: "trash",
    path: "/trash/:code",
    component: TrashPage,
  },
  {
    id: "group",
    path: "/group/:code",
    component: GroupPage,
  },
  {
    id: "bidding-statistics",
    path: "/bidding-statistics",
    component: BiddingStatisticsPage,
  },
];

export { publicRoutes, restrictedRoutes, privateRoutes };
